import axiosIns from '@/libs/axios'

export default {
  namespaced: true,

  actions: {
    // eslint-disable-next-line no-unused-vars
    fetchFraudTrips(ctx, queryParams) {
      return axiosIns.get('/trips/fraud', {
        params: queryParams,
      })
    },
  },
}
